import React from 'react';
import { connect } from 'react-redux';
import { withRenderFlag } from '@beef/react';
import { compose } from '@beef/redux';
import { Flex } from '@fttb/common/components';
import { isEmpty } from 'lodash';
import { Tag } from '@beef/ui-kit';
import { getTariffTags } from "../../../../store/blocks/tariffs/tariffSelectors";
import { IconWithTooltip } from "../IconWithTooltip";
export var _TariffTags = function _TariffTags(_ref) {
  var className = _ref.className,
    containerRef = _ref.containerRef,
    tags = _ref.tags;
  return /*#__PURE__*/React.createElement(Flex, {
    align: "right",
    className: className,
    "data-t-id": "components-TariffTags"
  }, tags.map(function (_ref2) {
    var color = _ref2.color,
      legal = _ref2.legal,
      text = _ref2.text;
    return /*#__PURE__*/React.createElement(Tag, {
      key: text,
      rightSideNode: legal ? /*#__PURE__*/React.createElement(IconWithTooltip, {
        containerRef: containerRef,
        message: legal
      }) : undefined,
      textColor: color === 'gold' ? 'black' : undefined,
      variant: color
    }, text);
  }));
};
var mapStateToProps = function mapStateToProps(state) {
  return {
    shouldRender: !isEmpty(getTariffTags(state)),
    tags: getTariffTags(state)
  };
};
export var TariffTags = compose(connect(mapStateToProps), withRenderFlag)(_TariffTags);